import "@zenlayer/zen-design/esm/tooltip/style";
import _Tooltip from "@zenlayer/zen-design/esm/tooltip";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import "@zenlayer/zen-design/esm/button/style";
import _Button from "@zenlayer/zen-design/esm/button";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import "@zenlayer/zen-design/esm/svg-icon/style";
import _SvgIcon from "@zenlayer/zen-design/esm/svg-icon";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick", "onExportProps"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { general_CSVExport_str } from '@zenlayer/zen-design-icons';
import React, { useState } from 'react';
import { onExport } from "../../function/onExport";
import t from '@zenlayer/zen-intl18';
/**
 * 导出按钮组件
 * @component
 */

import { jsx as _jsx } from "react/jsx-runtime";

var ExportButton = function ExportButton(props) {
  var onClick = props.onClick,
      onExportProps = props.onExportProps,
      otherProps = _objectWithoutProperties(props, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDowloading = _useState2[0],
      setIsDownloading = _useState2[1];

  return /*#__PURE__*/_jsx(_Tooltip, {
    title: t('Uh8wykDPal4B'),
    children: /*#__PURE__*/_jsx(_Button, _objectSpread({
      type: "normal",
      icon: /*#__PURE__*/_jsx(_SvgIcon, {
        svgStr: general_CSVExport_str
      }),
      size: "s",
      loading: isDowloading,
      onClick: /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  setIsDownloading(true);
                  _context.t0 = !!onExportProps;

                  if (!_context.t0) {
                    _context.next = 5;
                    break;
                  }

                  _context.next = 5;
                  return onExport(onExportProps);

                case 5:
                  _context.next = 7;
                  return onClick === null || onClick === void 0 ? void 0 : onClick(e);

                case 7:
                  setIsDownloading(false);

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()
    }, otherProps))
  });
};

export default ExportButton;